<template>

  <f7-card class="card-raised">
    <f7-card-content>
      <f7-list class="list-strong list-outline list-dividers" :dividers="false">
        <f7-list-item>
          <h6 class="my-0">
            €{{ amount }}
          </h6>
          <f7-badge :color="subscription.active ? 'green' : 'red'">
            {{ subscriptionStatus }}
          </f7-badge>
        </f7-list-item>
        <f7-list-item :disabled="!isManager" title="Type" smart-select :smart-select-params="{ openIn: 'sheet' }">
          <select name="subscription-type" v-model="subscription.subscription_type">
            <option :value="1" selected>Onbeperkt</option>
            <option :value="2">Personal training</option>
            <option :value="3">Bedrijfs Fitness Onbeperkt</option>
            <option :value="4">Bedrijfs Fitness PT</option>
            <option :value="5">Gratis</option>
          </select>
        </f7-list-item>
        <f7-list-item :disabled="!isManager" title="Looptijd" smart-select :smart-select-params="{ openIn: 'sheet' }">
          <select name="subscription-duration" v-model="subscription.looptijd">
            <option :value="1" selected>1 maand</option>
            <option :value="12">12 maanden</option>
          </select>
        </f7-list-item>
        <f7-list-item :disabled="!isManager" title="Betaling" smart-select :smart-select-params="{ openIn: 'sheet' }">
          <select name="subscription-frequency" v-model="subscription.frequency">
            <option :value="28" selected>4 weken</option>
            <option :value="31">Maandelijks</option>
          </select>
        </f7-list-item>
        <f7-list-item :disabled="!isManager" v-if="subscription.frequency === 31" title="Betaaldag" smart-select :smart-select-params="{ openIn: 'sheet' }">
          <select name="subscription-payment-day" v-model="subscription.payment_day_of_month">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="3">3</option>
            <option :value="4">4</option>
            <option :value="5">5</option>
            <option :value="6">6</option>
            <option :value="7">7</option>
            <option :value="8">8</option>
            <option :value="9">9</option>
            <option :value="10">10</option>
            <option :value="11">11</option>
            <option :value="12">12</option>
            <option :value="13">13</option>
            <option :value="14">14</option>
            <option :value="15">15</option>
            <option :value="16">16</option>
            <option :value="17">17</option>
            <option :value="18">18</option>
            <option :value="19">19</option>
            <option :value="20">20</option>
            <option :value="21">21</option>
            <option :value="22">22</option>
            <option :value="23">23</option>
            <option :value="24">24</option>
            <option :value="25">25</option>
            <option :value="26">26</option>
            <option :value="27">27</option>
            <option :value="28">28</option>
          </select>
        </f7-list-item>
        <f7-list-item :disabled="!isManager" >
          Start datum <span class="text-right">{{ subscription.created_at }}</span>
        </f7-list-item>
       <f7-list-item :disabled="!isManager" title="Stop datum">
            <f7-list-input
                name="end-date"
                v-model="subscription.end_date"
                :value="subscription.end_date"
                @input="subscription.end_date = $event.target.value"
                @change="updateSubscription('Het abonnement eindigt op ' + subscription.end_date, 'end')"
                type="date"
                placeholder=""
            ></f7-list-input>
        </f7-list-item>
        <f7-list-item :disabled="!isManager" title="Gepauzeerd vanaf">
            <f7-list-input
            name="paused-from-date"
            v-model="subscription.paused_from_date"
                :value="subscription.paused_from_date"
                @input="subscription.paused_from_date = $event.target.value"
                @change="updateSubscription('Het abonnement is gepauzeerd van ' + subscription.paused_from_date + ' t/m ' + subscription.paused_until_date , 'pause')"
                type="date"
                placeholder=""
            ></f7-list-input>
        </f7-list-item>
        <f7-list-item :disabled="!isManager" title="Gepauzeerd t/m">
            <f7-list-input
                name="paused-until-date"
                v-model="subscription.paused_until_date"
                :value="subscription.paused_until_date"
                @input="subscription.paused_until_date = $event.target.value"
                @change="updateSubscription('Het abonnement is gepauzeerd van ' + subscription.paused_from_date + ' t/m ' + subscription.paused_until_date, 'pause')"
                type="date"
                placeholder=""
            ></f7-list-input>
        </f7-list-item>
        <f7-list-item v-if="isManager">
          ID <span class="text-right">{{ subscription.mollie_customer_id }}</span>
        </f7-list-item>
        <!--
          NO v-if HERE, ON PURPOSE. Do not "restore security" by putting it back.

          The API has always served these rows to the member: UserFullResource:57
          -> SubscriptionResource:39 -> PaymentResource::collection(...),
          unconditionally, to anyone who passes UserPolicy::view() -- which for a
          member is `$authUser->id === $user->id` on their OWN record. The gate
          that used to be here was a DISPLAY decision, not an authorisation one;
          the payload was already in the member's browser and the template threw
          it away.

          Removing it is also what makes phase 40's payment pushes honest: both
          of them tell the member to open the app and look at a payment, and
          until now none could. (Phase 40 SC3.)

          The operator-only rows around this one -- mollie_customer_id above,
          the Activeren/Pauzeren/Stoppen footer below, payment_id and updated_at
          inside -- ARE still gated, and
          tests/components/account/UserSubscriptionDetails.test.js
          #a_member_does_not_get_the_admin_subscription_controls fails if that
          changes.
        -->
        <!--
          `accordion-item-opened` is Framework7's own prop
          (framework7-vue/components/list-item.js:180), and it is bound rather
          than hand-rolled on purpose: the component owns the open/closed state
          and the class that expresses it, so nothing here has to reach into f7
          imperatively or keep a second copy of that state.

          It is bound to a PROP and never to `isManager` or to anything read off
          the store. Which member's card this is, and therefore whether it opens,
          is the CALLER's business -- /account/abonnement opens the newest one,
          /users/:user_id opens it only on the viewer's own record. Deciding it
          here would need this component to know which page it is on.
        -->
        <f7-list-item accordion-item :accordion-item-opened="expanded" title="Betalingen">
          <f7-accordion-content>
            <f7-block inset>
              <p v-for="payment in subscription.payments" :key="payment.id">
                <f7-badge :color="paymentStatusColor(payment.status)">
                  €{{ payment.amount }}
                </f7-badge>
                <strong class="ml-2">
                  {{ paymentStatusLabel(payment.status) }}
                </strong><br/>
                {{ paymentDate(payment.created_at) }}
                <template v-if="isManager">
                  <br/>Bijgewerkt @ {{ payment.updated_at }}
                  <br/>ID {{ payment.payment_id }}
                </template>
              </p>
            </f7-block>
          </f7-accordion-content>
        </f7-list-item>
      </f7-list>
    </f7-card-content>
    <f7-card-footer class="no-border" v-if="isManager">
      <f7-button v-if="!subscription.active" fill class="d-block" color="green" @click="startSubscription">Activeren</f7-button>
      <f7-button v-if="subscription.active" fill class="d-block" color="orange" @click="pauseSubscription">Pauzeren</f7-button>
      <f7-button v-if="subscription.active" fill class="d-block" color="red" @click="endSubscription">Stoppen</f7-button>
    </f7-card-footer>
  </f7-card>
</template>

<script>

import {f7} from "framework7-vue";
import moment from "moment";
import utility from "@/js/utility";

// The server's own vocabulary, mapped to something a member can read.
//
// `Onbekende status` is not a typo and not an error state: PaymentResource:27 is
// `$payment->status ?: 'Onbekende status'`, and MollieService::storePayment()
// creates every Payment with status NULL -- 100 production rows were in that
// state when this was measured. It is the FIRST thing a member sees after an
// InvoiceAvailableNotification, which fires on Payment::created, so it must not
// be red.
const PAYMENT_STATUS_LABELS = {
  paid:                'Betaald',
  failed:              'Mislukt',
  chargeback:          'Teruggeboekt',
  open:                'In behandeling',
  pending:             'In behandeling',
  expired:             'Verlopen',
  canceled:            'Geannuleerd',
  'Onbekende status':  'Nog niet verwerkt',
};

// Only the two statuses the server itself treats as a failure
// (PaymentObserver::FAILURE_STATUSES = ['failed', 'chargeback']) are red.
// Everything else is neutral -- a flow state is not bad news.
const PAYMENT_STATUS_COLORS = {
  paid:       'green',
  failed:     'red',
  chargeback: 'red',
};

export default {
  components: {},

  props: {
    subscription: Object,
    user: Object,

    /**
     * Open the Betalingen accordion on arrival (40-09, finding F17).
     *
     * DEFAULT CLOSED, and the default is written out although Vue would supply
     * `false` for an absent Boolean prop anyway. Two callers pass it and both
     * pass it conditionally, so the value that matters most is the one nobody
     * writes down: the card as it renders everywhere it is not asked to open.
     *
     * The mutation that pins this is `default: true`, NOT deleting the default
     * -- deleting it changes nothing, because Vue casts a missing Boolean prop
     * to false regardless. Measured; see 40-09-SUMMARY.md.
     */
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['updateSubscription'],

  mixins: [],

  data: function () {
    return {
      //
    };
  },

  computed: {
    subscriptionStatus() {
      if(this.subscription.end_date !== null) {
        if(moment(this.subscription.end_date).isAfter(moment().startOf('day'))) {
          return 'Gaat stoppen';
        }
      }
      if(this.subscription.paused_until_date !== null) {
        if(moment(this.subscription.paused_until_date).isAfter(moment().startOf('day'))) {
          return 'Gepauzeerd';
        }
      }
      return this.subscription.active ? 'Actief' : 'Gestopt';
    },
    current_user() {
      return this.$store.state.current_user.data;
    },
    isManager() {
      return this.current_user.is_admin;
    },
    amount() {
      return utility.roundDownToTwo(this.subscription.amount * ((100 - this.user.discount_percentage) / 100));
    }
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    /** An unknown status falls through to the raw value rather than to a blank. */
    paymentStatusLabel(status) {
      return PAYMENT_STATUS_LABELS[status] || status;
    },
    /** Anything not in the failure map is neutral, never red. */
    paymentStatusColor(status) {
      return PAYMENT_STATUS_COLORS[status] || 'gray';
    },
    /**
     * DD-MM-YYYY is deliberate and has no locale dependency.
     *
     * This file imports plain `moment` and never calls `moment.locale('nl')`,
     * but six other modules in this app DO -- payments.vue, reserveringen.vue,
     * news.vue, NewsComposer.vue, payment-single/success.vue -- and
     * moment.locale() is a GLOBAL mutation. So the locale in force here depends
     * on which screens the member happened to visit first, and an `MMMM` format
     * would render English or Dutch month names accordingly. A numeric format
     * cannot.
     */
    paymentDate(value) {
      return value ? moment(value).format('DD-MM-YYYY') : '';
    },
    pauseSubscription() {
      let vm = this;
      let today = moment().format('YYYY-MM-DD');
      let twoWeeksFromNow = moment().add(14, 'days').format('YYYY-MM-DD');
      f7.dialog.prompt('Wil je dit abonnement van ' + vm.user.name + ' pauzeren?', 'Vanaf wanneer', function (pausedFromDate) {
            f7.dialog.prompt('Wil je dit abonnement van ' + vm.user.name + ' pauzeren?', 'Tot wanneer', function (pausedUntilDate) {

              let subscription = vm.subscription;
              subscription.paused_from_date = pausedFromDate;
              subscription.paused_until_date = pausedUntilDate;
              vm.updateSubscription('Het abonnement is gepauzeerd van ' + pausedFromDate + ' t/m ' + pausedUntilDate , 'pause');
            }, null, twoWeeksFromNow);
      }, null, today);
    },
    endSubscription() {
      let vm = this;
      let nextMonth = moment().add(1, 'month').format('YYYY-MM-DD');
      f7.dialog.prompt('Wil je dit abonnement van ' + this.user.name + ' stoppen?', 'Per wanneer', function (endDate) {
        vm.subscription.end_date = endDate;
        vm.updateSubscription('Het abonnement is stop gezet per ' + endDate , 'end');
      }, null, nextMonth);
    },
    startSubscription() {
      let vm = this;
      let today = moment().format('YYYY-MM-DD');
      f7.dialog.prompt('Wil je dit abonnement van ' + this.user.name + ' weer starten?', 'Per wanneer', function (startDate) {
        vm.subscription.start_date = startDate;
        vm.updateSubscription('Het abonnement zal vanaf ' + startDate + ' automatisch weer starten (in de nacht)' , 'start');
      }, null, today);
    },
    updateSubscription(successMessage, type) {
      let vm = this;
      vm.$store.commit('app/show_loader');
      vm.$store.dispatch('api/postEndpoint', {
        endpoint: '/subscriptions/' + vm.subscription.id + '/' + type,
        data: vm.subscription,
      }).then(response => {
        vm.$store.dispatch('notifications/addSuccessNotification', {
          message: successMessage,
        });
        vm.$emit('updateSubscription', response.data.data);
      })
      .finally(() => {
        vm.$store.commit('app/hide_loader');
      })
    }
  },

  watch: {
    'subscription.subscription_type': {
      handler(value, oldValue) {
        if(oldValue !== value) {
          this.updateSubscription('Het abonnement type is veranderd', 'subscription-type');
        }
      }
    },
    'subscription.looptijd': {
      handler(value, oldValue)
      {
        if(oldValue !== value) {
          this.updateSubscription('De looptijd van het abonnement is veranderd', 'looptijd');
        }
      }
    },
    'subscription.frequency': {
      handler(value, oldValue)
      {
        if(oldValue !== value) {
          this.updateSubscription('De frequentie van het abonnement is veranderd', 'frequency');
        }
      }
    },
    'subscription.payment_day_of_month': {
      handler(value, oldValue)
      {
        if(oldValue !== value) {
          this.updateSubscription('De dag van betaling van het abonnement is veranderd', 'payment_day_of_month');
        }
      }
    }
  }
};
</script>
